import React from 'react'
import ShippingOrderDelete from "./ShippingOrderDelete";
import ShippingOrderEdit from "./ShippingOrderEdit";
import ShippingOrderPrintContainer from "./print/ShippingOrderPrintContainer";

const ShippingOrderActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <ShippingOrderEdit shipping={record}/>
            <ShippingOrderPrintContainer shippingId={record.id} />
            <ShippingOrderDelete shippingOrder={record} updater={updater} />
        </React.Fragment>
    )
}
export default ShippingOrderActions